import React from "react";
import { useField, useFormikContext } from "formik";
import { Dropdown } from "semantic-ui-react";

export default function FormDropdown({
  ...props
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
{ [x: string]: any } & { name: string }): JSX.Element {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  return (
    <>
      <Dropdown
        selection
        {...field}
        {...props}
        onChange={(e, { value }) => setFieldValue(props.name, value, true)}
      />
      {meta.touched && meta.error ? (
        <div className="FormError">{meta.error}</div>
      ) : null}
    </>
  );
}
